import React from 'react';
import { Hero } from './components/Hero';
import { PainPoint } from './components/PainPoint';
import { WhyFailed } from './components/WhyFailed';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoItsFor } from './components/WhoItsFor';
import { HowItWorks } from './components/HowItWorks';
import { Transformation } from './components/Transformation';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-brown selection:bg-terracotta selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoint data-id="element-3" />
        <WhyFailed data-id="element-4" />
        <Solution data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <WhoItsFor data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Transformation data-id="element-9" />
        <FAQ data-id="element-10" />
        <Pricing data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}